// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const Country = {
  UnitedStates: {
    Name: 'United States',
    Value: 'US',
  },
  Canada: {
    Name: 'Canada',
    Value: 'CA',
  },
} as const

export type CountryValue = (typeof Country)[keyof typeof Country]['Value']
